import { createFormDataRequest } from "@/helpers/FormHelpers";
import { IFilters, IPaginateResponse } from "@/interfaces/Fetch";
import Person from "@/interfaces/Person";
import api from "../api";

export const companyPeopleApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCompanyPeople: build.query<
      IPaginateResponse<Person>,
      [string, IFilters]
    >({
      query: ([id, data]) => {
        const params = createFormDataRequest(data);
        return {
          url: `/companies/${id}/people`,
          params,
        };
      },
      providesTags: (result, _error, [companyId]) =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: "CompanyPeople" as const,
                id,
              })),
              { type: "CompanyPeople", companyId, id: "LIST" },
            ]
          : [],
    }),
  }),
  overrideExisting: true,
});

export const { useGetCompanyPeopleQuery, useLazyGetCompanyPeopleQuery } =
  companyPeopleApi;
